import React from "react";
import mhcLogo from "../../assets/images/boots-myhealthchecked-logo.svg";
import CreateAccount from "../../components/Account/CreateAccount";
import Footer from "../../components/Layout/Footer";
import backArrow from "../../assets/images/back-arrow.svg";
import backarrowlogo from "../../assets/images/back-arrow-mobile-1.svg";
import { useMediaQuery, } from "react-responsive";
import PropTypes from "prop-types";
const AccountCard = ({
  children,
  loginPage = false,
  title,
  finished = false,
  createaccount = false,
  resetPasswordPage = false,
  verifyPage = false,
  resendPage = false,
  isphlebo = false,
  isPhlebotomist = false,
}) => {

  return (
    <div
      className={`initial-form-wrapper ${(createaccount || resetPasswordPage || verifyPage || isphlebo || isphlebo || isPhlebotomist) &&
        "main-wrapper"} ${createaccount &&
        "create-account-card"} login-wrapper ${verifyPage ? "verify-wrapper" : ""} ${resendPage ? "resend-email-wrapper" : ""} ${isphlebo && "phlebotomist-initial"}`}
    >
      {loginPage && <img className="logo-layout" src={mhcLogo} alt="mhc-logo" />}
      {isPhlebotomist && <div className="phlebo-existing-user"><span>You already have an account with us.</span> <small>Please enter your password to continue.</small></div>}
      <div
        className={`container card login-card  ${isPhlebotomist && "phlebotomist-card"}`}
      >
        <div className="row">
          <div
            className={`col-12 ${loginPage ? "col-lg-6 col-md-6 p-0 login-form-wrapper" : "col-lg-12"
              } `}
          >
            <div className={`title-wrapper ${(loginPage || isPhlebotomist) && "mb-4"}`}>
              <p className={`login-form-title ageo-bold ${loginPage || isPhlebotomist ? "fs-28" : "fs-24"}`}>{title}</p>
            </div>

            {createaccount && (
              
                finished ? (
                  <div className="lead">
                    <p>
                      Please check your email to confirm your new account and
                      login.
                    </p>
                    <p>You can safely close this window.</p>
                  </div>
                ) : (
                  <p className="lead">
                    Create an account to register your test and view results.
                  </p>
                )
              
            )}

            {children}
          </div>
          {loginPage && <CreateAccount />}
        </div>
      </div>
      <Footer />
    </div>
  );
};

AccountCard.propTypes = {
  children: PropTypes.node,
  loginPage: PropTypes.bool,
  title: PropTypes.string,
  finished: PropTypes.bool,
  createaccount: PropTypes.bool,
  resetPasswordPage: PropTypes.bool,
  verifyPage: PropTypes.bool,
  resendPage: PropTypes.bool,
  isphlebo: PropTypes.bool,
};


export default AccountCard;
